"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWindowSize = void 0;
var _esToolkit = require("es-toolkit");
var _react = require("react");
const getWindowWidth = () => window.innerWidth;
const getServerWindowWidth = () => 0;
const getWindowHeight = () => window.innerHeight;
const getServerWindowHeight = () => 0;
const subscribeWindowResize = (listener, delay) => {
  const debouncedListener = (0, _esToolkit.debounce)(listener, delay);
  window.addEventListener('resize', debouncedListener);
  return () => window.removeEventListener('resize', debouncedListener);
};

/**
 * Hook that returns the current window size.
 */
const useWindowSize = ({
  delay = 250
} = {}) => {
  const subscribeWidth = (0, _react.useCallback)(listener => subscribeWindowResize(listener, delay), [delay]);
  const subscribeHeight = (0, _react.useCallback)(listener => subscribeWindowResize(listener, delay), [delay]);

  // Use two stores for width and height, as each needs its own snapshot for immutability
  const width = (0, _react.useSyncExternalStore)(subscribeWidth, getWindowWidth, getServerWindowWidth);
  const height = (0, _react.useSyncExternalStore)(subscribeHeight, getWindowHeight, getServerWindowHeight);
  return {
    width,
    height
  };
};
exports.useWindowSize = useWindowSize;
//# sourceMappingURL=useWindowSize.js.map